module.exports = __webpack_public_path__ + "static/media/top-img_7_mob.279b13ff.png";